export default "__VITE_ASSET__9643d559__"